import { useEffect } from "react";

const useDomain = () => {

  const getSubDomain = () => {
    const sub_domain = location.hostname.indexOf('dev') >= 0
      ? 'dev'
      : location.hostname.indexOf('qa') >= 0
        ? 'qa'
        : '';
    return sub_domain;
  }

  // const getCookieDomain = () => {
  //   return window.location.hostname.split('.').map((part, idx) => {
  //     return idx > 0 ? part : ''
  //   }).join('.');
  // }

  useEffect(() => {
    // document.domain = window.location.hostname.split('.').map((part, idx) => {
    //   return (idx == 0 && part.indexOf('portal') == 0) ? 'portal' : part
    // }).join('.')
    // document.domain = getCookieDomain().substring(1);
  }, []);

  return { getSubDomain };

}

export default useDomain;